import EditorJs, {
  EditorProps,
} from '@/components/ui/custom/dataInput/EditorJS';
import SectionSkeleton from '@/components/ui/custom/material/slides/sections/SectionSkeleton';
import useCodeEditorTool from '@/data/hook/editorjs/useCodeEditorTool';
import useMaterialImageGeneratorTool from '@/data/hook/editorjs/useMaterialImageGeneratorTool';
import { ImageFolderEnum } from '@/models/CkEditor';

type MaterialEditorJSProps = EditorProps & {
  lessonId?: number;
};

export default function MaterialEditorJS({
  value,
  onChange,
  extraBody,
  activityBlock,
  lessonId,
  ...props
}: MaterialEditorJSProps) {
  const { tool: imageGeneratorTool } = useMaterialImageGeneratorTool({
    lessonId,
  });

  const { isLoading: isLoadingCodeEditor, tool: codeEditorTool } =
    useCodeEditorTool();

  if (isLoadingCodeEditor) return <SectionSkeleton />;

  if (props.readOnly) {
    return (
      <EditorJs
        value={value}
        onChange={onChange}
        extraBody={extraBody}
        minHeight={0}
        activityBlock={activityBlock}
        codeEditorBlock={codeEditorTool}
        imageGeneratorBlock={imageGeneratorTool}
        {...props}
      />
    );
  }

  return (
    <EditorJs
      value={value}
      onChange={onChange}
      extraBody={extraBody}
      minHeight={0}
      activityBlock={activityBlock}
      codeEditorBlock={codeEditorTool}
      imageGeneratorBlock={imageGeneratorTool}
      {...props}
      folder={ImageFolderEnum.BOOK}
    />
  );
}
